import React from "react";
import { TreeNodeId } from "../hooks/use-tree";
import { AnnotatedFunction } from "../types/annotated-function";
import { FunctionCallHandler } from "../types/ai-function";
import { CompletionCreateParams } from "openai/resources/chat";

export interface CopilotContextParams {
  entryPoints: Record<string, AnnotatedFunction<any[]>>;
  setEntryPoint: (id: string, entryPoint: AnnotatedFunction<any[]>) => void;
  removeEntryPoint: (id: string) => void;
  getChatCompletionFunctionDescriptions: () => CompletionCreateParams.Function[];
  getFunctionCallHandler: () => FunctionCallHandler;

  getContextString: (categories?: string[]) => string;
  addContext: (
    context: string,
    parentId?: string,
    categories?: string[],
  ) => TreeNodeId;
  removeContext: (id: TreeNodeId) => void;
}

const emptyCopilotContext: CopilotContextParams = {
  entryPoints: {},
  setEntryPoint: () => {},
  removeEntryPoint: () => {},
  getChatCompletionFunctionDescriptions: () => returnAndThrowInDebug(),
  getFunctionCallHandler: () => returnAndThrowInDebug(),

  getContextString: () => returnAndThrowInDebug(),
  addContext: () => "",
  removeContext: () => {},
};

export const CopilotContext =
  React.createContext<CopilotContextParams>(emptyCopilotContext);

function returnAndThrowInDebug<T>(): T {
  throw new Error(
    "Remember to wrap your app in a `<CopilotProvider> {...} </CopilotProvider>` !!!",
  );
}
